module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div id="alarm-slider"><dl v-show="model.modelError"><dd><p class="error">ERROR! {{ model.modelError }}</p></dd></dl><label for="edit-alarm">{{ tc(\'Switches\', \'Alarm Switch:\') }}</label><div id="edit-alarm" class="input"><defa-radio-strip v-model="intrusionSwitchValue" :options="intrusionSwitchOptions" v-bind:class="{ errorState:  model.intrusionSwitch === null}" v-on:input="save($event, \'intrusionSwitch\')"></defa-radio-strip><p v-show="model.intrusionSwitchError" class="error">{{ model.intrusionSwitchError }}</p></div></div>';
}
return __p;
};
